import ResizeObserver from 'resize-observer-polyfill';

export const StyleResizeObserverMixin = (SuperClass) => class extends SuperClass {

  observeAndSetStyles(observedNode=window.__slicesuiResizeObserveNode || this, rootNode=document.body) {
    if(window._slicesuiStyleResizeObserver !== undefined) return;
    window._slicesuiStyleResizeObserver = new ResizeObserver(() => {
      window.requestAnimationFrame(() => {
        const ew = Math.min(observedNode === document.body ? window.innerWidth : observedNode.offsetWidth, window.innerWidth);
        const eh = Math.min(observedNode === document.body ? window.innerHeight : observedNode.offsetHeight, window.innerHeight);
        const eMin = Math.min( ew, eh ) / 100;
        const eClamp = Math.max(Math.min(eMin, 7), 4);
        rootNode.style.setProperty('--emin', `${eMin}px`);
        rootNode.style.setProperty('--ew', `${ew}px`);
        rootNode.style.setProperty('--eh', `${eh}px`);
        rootNode.style.setProperty('--eclamp', `${eClamp}px`);
        rootNode.style.setProperty('--erem', `${eClamp * 4}px`);
      });
    });
    window._slicesuiStyleResizeObserver.observe(observedNode);  
  }
};